import feniche_response_tab_test from '../../../../store/response/tabTest';

export default {
  created() {
    this.$store.registerModule('feniche_response_tab_test', feniche_response_tab_test);
  },
  destroyed() {
    this.$store.unregisterModule('feniche_response_tab_test');
  }
}